import React from 'react'
import { Link } from 'react-router-dom'
import { APP_NAME } from '../../brand'

class TOS extends React.Component {
  render() {
    return (
      <div className="ng-legal">
        <div className="ng-legal-nav">
          <Link to="/tos" className="ng-legal-tab ng-legal-tab--active">Terms of Service</Link>
          <Link to="/privacy" className="ng-legal-tab">Privacy Policy</Link>
        </div>

        <div className="ng-legal-hero">
          <div className="ng-legal-icon">📋</div>
          <h1>Terms of Service</h1>
          <p className="ng-legal-subtitle">Last updated: August 2026</p>
        </div>

        <div className="ng-legal-body">
          <section className="ng-legal-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to <strong>{APP_NAME}</strong> ("the Platform"), a marketplace that
              connects licensed real-estate agents: buyer's agents who need a property
              showing covered, and showing agents who cover it for an agreed fee. By using
              the Platform you agree to be bound by these Terms. If you do not agree,
              please do not use the Platform.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>2. Eligibility and accounts</h2>
            <p>
              The Platform is available only to licensed real-estate professionals. You
              represent that you hold a valid, active real-estate license in each state
              where you act through the Platform, and that the license details you submit
              are accurate. You are responsible for keeping your credentials confidential
              and for all activity under your account; notify us immediately of any
              unauthorized use.
            </p>
            <div className="ng-legal-card">
              <strong>Account roles:</strong>
              <ul>
                <li><strong>Buyer's agent</strong> — posts showing requests with an address, a time window, and a fee.</li>
                <li><strong>Showing agent</strong> — accepts requests, conducts the showing, and files a showing report.</li>
                <li><strong>Both</strong> — an account may act in either role.</li>
              </ul>
            </div>
          </section>

          <section className="ng-legal-section">
            <h2>3. Showings</h2>
            <p>
              Accepting a showing is a commitment to attend within the stated window,
              conduct the showing professionally, and file a report afterwards. Repeated
              no-shows or late withdrawals may lead to suspension. Property access
              information (lockbox codes, gate instructions) is shared only with the agent
              who accepted the showing and may be used solely to conduct that showing.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>4. Fees</h2>
            <p>
              Showing fees are agreed between the two agents through the Platform. Until
              integrated payments are available, settlement of fees is the responsibility
              of the two agents; the Platform is not a party to the fee agreement and does
              not guarantee payment.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>5. No agency relationship</h2>
            <p>
              A showing agent acts as a neutral door-opener on behalf of the requesting
              buyer's agent. Nothing on the Platform creates an agency relationship between
              the showing agent and the buyer, and showing reports are informational only —
              they are not real-estate advice, appraisals, or legal counsel.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>6. Acceptable use</h2>
            <p>
              Use the Platform only for lawful purposes. Do not post false showings, file
              false reports or reviews, share access information with third parties, or
              harass other users. We may remove content or suspend accounts that violate
              these rules.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>7. Account deletion</h2>
            <p>
              You can delete your account from your profile at any time. On deletion your
              personal contact details are removed from your account record; records of
              completed showings are retained as required for the other party's business
              records and by applicable law.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>8. Disclaimers and liability</h2>
            <p>
              The Platform is provided "as is" and "as available", without warranties of
              any kind. We do not guarantee the accuracy of property information supplied
              by users, the conduct of any agent, or the outcome of any showing. To the
              maximum extent permitted by law, the Platform shall not be liable for
              indirect, incidental, punitive, or consequential damages arising from use of
              the service, including disputes between agents, missed showings, or
              unsettled fees.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>9. Changes to these Terms</h2>
            <p>
              We may modify these Terms; material changes will be announced at least 30
              days before taking effect. Continued use after changes take effect
              constitutes acceptance.
            </p>
          </section>
        </div>
      </div>
    )
  }
}

export default TOS
